import * as React from "react";
import {
  Provider as PaperProvider,
  Text,
  TextInput,
  DefaultTheme,
  Checkbox,
  Divider,
} from "react-native-paper";
import { Image, StyleSheet, View, ScrollView } from "react-native";
import { connect } from "react-redux";
import { actionCreators } from "./action";
import { actionCreators as actionCreatorsForgotPassword } from "../ForgotPassword/action";
import {
  whiteColor,
  blackColor,
  greyColor,
  linkColorForgot,
  redBorderInputColor,
  redBackgroundColor,
} from "../../common/colors";
import { linkColor } from "../../common/colors";
import routes from "../../routing/routes";
import Button from "../../common/Button";
import Link from "../../common/Link";
import Error from "../../common/Error";
import ErrorAgreement from "../../common/Error/ErrorTerms";
import ErrorPasswordLength from "../../common/Error/ErrorPasswordLength";
import checker from "../../common/helpers/checker";
import useKeypress from "react-use-keypress";
import logoApple from "../Images/LogoApple.png";
import logoFacebook from "../Images/LogoFacebook.png";
import logoGoogle from "../Images/LogoGoogle.png";
import PageContainer from "../../common/PageContainer";
import MAX_WIDTH from '../../common/MaxWidth';
import t from '../../translations';

const RegistrationForm = (props) => {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [repeatpassword, setRepeatPassword] = React.useState("");
  const [checked, setChecked] = React.useState(false);

  // useKeypress('Enter', () => {
  //     onPressButton();
  // });

  React.useEffect(() => {
    if (props.error) {
      props.saveErrorReponse(null);
    }
    return () => {
      props.saveErrorReponse(null);
    };
  }, []);

  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const onClickLink = () => props.navigation.navigate(routes.SignIn);
  const isWrongPassword =
    props.errorCode === "auth/wrong-password" ||
    props.errorCode === "auth/weak-password" ||
    props.errorCode === "auth/different-passwords";
  const agreementNotChecked = props.errorCode === "auth/agreementNotChecked";
  const isNotWrongPassword =
    !isWrongPassword && !agreementNotChecked && props.error;
  const onClickGoToAgreement = () =>
    props.navigation.navigate(routes.Agreement);
  const onClickGoToPrivacy = () => props.navigation.navigate(routes.Privacy);
  const onPressButton = () =>
    props.signUp({
      email,
      password,
      repeatpassword,
      checked,
      redirect: props.navigation.navigate,
    });

  return (
    <PageContainer
    {...props}
    noBackground={true}
    isBackIcon={true}
    backRoute={routes.Start}
    maxWidth={MAX_WIDTH.AUTHENTICATION}
    >
      <View style={styles.container}>
        <Text style={styles.title}>{t('registrationForm_title')}</Text>
      </View>
      <View style={styles.inputsContainer}>
        <TextInput
          label={t('registrationForm_e_mail')}
          value={email}
          onChangeText={(text) => {
            setEmail(text);
            isNotWrongPassword && props.saveErrorReponse(null);
          }}
          mode="outlined"
          returnKeyType="done"
          error={isNotWrongPassword && { ...styles.inputBorderError, width: '100%' }}
          style={isNotWrongPassword ? { ...styles.inputError, width: '100%' } 
            : { ...styles.input, width: '100%' }}
        />
        {isNotWrongPassword && <Error error={props.error} />}
        <TextInput
          label={t('registrationForm_password')}
          value={password}
          secureTextEntry={true}
          onChangeText={(text) => {
            setPassword(text);
            isWrongPassword && props.saveErrorReponse(null);
          }}
          mode="outlined"
          returnKeyType="done"
          error={isWrongPassword && { ...styles.inputBorderError, width: '100%' }}
          style={isWrongPassword ? { ...styles.inputError, width: '100%' } 
          : { ...styles.input, width: '100%' }}
        />
        {isWrongPassword && <ErrorPasswordLength error={props.error} />}
        <TextInput
          label={t('registrationForm_repeat_password')}
          value={repeatpassword}
          secureTextEntry={true}
          onChangeText={(text) => {
            setRepeatPassword(text);
            isWrongPassword && props.saveErrorReponse(null);
          }}
          mode="outlined"
          returnKeyType="go"
          onSubmitEditing={onPressButton}
          error={isWrongPassword && { ...styles.inputBorderError, width: '100%' }}
          style={isWrongPassword ? { ...styles.inputError, width: '100%' } 
            : { ...styles.inputrepeat, width: '100%' }} 
        />
        {isWrongPassword && <ErrorPasswordLength error={props.error} />}
        <View style={styles.inputsContainerLeft}>
          <View style={styles.checkboxContainer}>
            <Checkbox.Android
              status={checked ? "checked" : "unchecked"}
              onPress={() => {
                setChecked(!checked);
                agreementNotChecked && props.saveErrorReponse(null);
              }}
              color={linkColor}
              uncheckedColor={agreementNotChecked ? "red" : greyColor}
              label="Item"
            />
            <View style={styles.agreementbox}>
              <Text style={styles.agreementtext}>
              {t('registrationForm_agree')}
                <Text style={styles.breaklinetext}>{"\n"}Loriini</Text>
              </Text>
              <Text
                style={styles.linktoterms}
                onPress={onClickGoToAgreement}
              >
                {" "}
                {t('registrationForm_agrement')}
              </Text>
              <Text style={styles.agreementtext}> {t('registartionForm_and')} </Text>
              <Text style={styles.linktoterms} onPress={onClickGoToPrivacy}>
              {t('registrationForm_privacy_policy')}
              </Text>
            </View>
          </View>
        </View>
        {agreementNotChecked && <ErrorAgreement error={props.error} />}
        <View style={styles.buttonContainer}>
          <Button onPress={onPressButton} value={t('registartionForm_create_a_profile')} />
        </View>
        {/* <View style={styles.linecontainer}>  
                <Divider style={styles.breakline}>
                <Text style={styles.or}>Lub</Text>
                </Divider>
            </View>
            <View style={styles.continue}>
                <Text style={styles.continuewithaccounts}>Stwórz profil z:</Text>
            </View>
            <View style={styles.logoicons}>
                <View style={styles.emptyspace}>
                    <Image source={logoApple} style={styles.logo}/>
                </View>
                <View style={styles.emptyspace}>
                    <Image source={logoFacebook} style={styles.logo}/>
                </View>
                <Image source={logoGoogle} style={styles.logo}/>
            </View> */}
        <View style={styles.inputsContainerLeft}>
          <View style={styles.footerContainer}>
            <Text style={styles.askbox}>{t('registartionFrom_do_you_have_a_profile')}</Text>
            <Link onPress={onClickLink}>{t('registartionForm_sign_in')}</Link>
          </View>
        </View>
      </View>
    </PageContainer>
  );
};

const mapStateToProps = (state) => {
  const errorMessage = state.errorMessages && checker(state.errorMessages.code);
  const errorCode = state.errorMessages ? state.errorMessages.code : "";

  return { error: errorMessage, errorCode };
};

export default connect(mapStateToProps, {
  ...actionCreators,
  ...actionCreatorsForgotPassword,
})(RegistrationForm);

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 30,
    backgroundColor: whiteColor,
  },
  agreementbox: {
    display: "flex",
    flexDirection: "row",
    paddingLeft: 4,
  },
  agreementtext: {
    paddingTop: 6,
    fontSize: 12,
    color: greyColor,
    letterSpacing: 1.25,
    lineHeight: 13,
  },
  linktoterms: {
    paddingTop: 6,
    fontSize: 12,
    color: linkColorForgot,
    letterSpacing: 1.25,
    lineHeight: 13,
  },
  breaklinetext: {
    textAlign: "left",
    fontSize: 12,
    color: greyColor,
    letterSpacing: 1.25,
    lineHeight: 13,
  },
  checkbox: {
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "row",
    marginLeft: -9,
  },
  inputsContainer: {
    backgroundColor: whiteColor,
    alignItems: "flex-start",
    display: "flex",
    width: '100%',
  },
  input: {
    color: "red",
    paddingTop: 10,
    paddingBottom: 22,
    height: 42,
    backgroundColor: whiteColor,
    width: '100%',
  },
  inputrepeat: {
    color: "red",
    paddingTop: 2,
    paddingBottom: 4,
    height: 42,
    backgroundColor: whiteColor,
  },
  inputBorderError: {
    borderColor: redBorderInputColor,
    borderWidth: 1,
    borderStyle: "solid",
  },
  inputError: {
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: redBackgroundColor,
    height: 42,
  },
  container: {
    backgroundColor: whiteColor,
    alignItems: 'flex-start',
  },
  title: {
    textAlign: "center",
    fontSize: 26,
    letterSpacing: 1.25,
    textTransform: "uppercase",
  },
  divider: {
    height: 10,
    backgroundColor: whiteColor,
  },
  buttonContainer: {
    alignItems: "center",
    display: "flex",
    paddingTop: 10,
    alignSelf: 'center',
  },
  linecontainer: {
    backgroundColor: whiteColor,
    width: 260,
    paddingTop: 30,
    paddingBottom: 16,
  },
  breakline: {
    height: 1,
    backgroundColor: greyColor,
  },
  or: {
    textAlign: "center",
    alignSelf: "center",
    width: 45,
    height: 10,
    marginTop: -6,
    color: greyColor,
    fontSize: 10,
    letterSpacing: 1.25,
    backgroundColor: whiteColor,
  },
  continue: {
    paddingTop: 2,
  },
  continuewithaccounts: {
    color: blackColor,
    fontSize: 12,
    letterSpacing: 1.25,
  },
  logoicons: {
    paddingTop: 12,
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },
  logo: {
    width: 56,
    height: 56,
    alignItems: "center",
  },
  footerContainer: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    paddingTop: 20,
  },
  askbox: {
    fontSize: 12,
    letterSpacing: 1.25,
    color: greyColor,
  },
  link: {
    color: linkColor,
  },
  inputsContainerLeft: {
    backgroundColor: whiteColor,
    alignItems: "flex-start",
    paddingBottom: 40,
    width: '100%',
  },
});
